var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._l((_vm.contents),function(content){return [(_vm.isLink(content))?[_c('RouterLink',{class:_vm.linkClass,attrs:{"to":_vm.links[content.tag].to}},[_vm._v("\n        "+_vm._s(_vm.links[content.tag].text)+"\n      ")])]:[_vm._v("\n      "+_vm._s(content)+"\n    ")]]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }